/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 40ad59d7 (Wed Jul 15 19:12:51 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  CommunityFamiliesReportRow,
  CommunityFamiliesReportRowFromJSON,
  CommunityFamiliesReportRowToJSON,
} from './'

/**
 *
 * @export
 * @interface CommunityFamiliesReportResponse
 */
export interface CommunityFamiliesReportResponse {
  /**
   * One row per enrollment for every family the current user can access within the community.
   * @type {Array<CommunityFamiliesReportRow>}
   * @memberof CommunityFamiliesReportResponse
   */
  data: Array<CommunityFamiliesReportRow>
}

export function CommunityFamiliesReportResponseFromJSON(
  json: any
): CommunityFamiliesReportResponse {
  return CommunityFamiliesReportResponseFromJSONTyped(json, false)
}

export function CommunityFamiliesReportResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CommunityFamiliesReportResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(CommunityFamiliesReportRowFromJSON),
  }
}

export function CommunityFamiliesReportResponseToJSON(
  value?: CommunityFamiliesReportResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(CommunityFamiliesReportRowToJSON),
  }
}
